import { z } from '../zod';

const supportedCurrencies = [
  'aed',
  'aud',
  'brl',
  'cad',
  'chf',
  'clp',
  'czk',
  'dkk',
  'eur',
  'gbp',
  'hkd',
  'inr',
  'jpy',
  'mxn',
  'myr',
  'nok',
  'nzd',
  'ron',
  'php',
  'pln',
  'sek',
  'sgd',
  'usd',
  'zar',
  'thb',
];

export const SupportedCurrencyEnum = z.enum(supportedCurrencies);

export const CouponDurationEnum = z.enum(['once', 'repeating', 'forever']).meta({
  description:
    'How long the discount lasts: `once` applies to the first eligible payment, `repeating` applies for a fixed number of months, and `forever` applies until canceled or expired.',
});
